import { LicensePlate } from "@/components/my-auctions/LicensePlate";
import { Tag, Car } from "lucide-react";
import { getLanguage } from "@/utils/languageUtils";
import { leadUILabels } from "@/i18n";

interface LaedCardHeaderProps {
  regNumber: string;
  make: string;
  model: string;
}

export const LeadCardHeader = ({
  regNumber,
  make,
  model,
}: LaedCardHeaderProps) => {
  const uiLabels = leadUILabels(getLanguage());
  
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-6 gap-2">
        <div className="flex items-center gap-1 sm:gap-2">
          <Tag className="h-4 w-4 text-muted-foreground" />
          <div>
            <div className="text-xs text-muted-foreground">{uiLabels.registrationNumber}</div>
            <LicensePlate lpn={regNumber} />
          </div>
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          <Car className="h-4 w-4 text-muted-foreground" />
          <div>
            <div className="text-xs text-muted-foreground">{uiLabels.vehicle}</div>
            <div className="font-semibold text-xs sm:text-base truncate">
              {make} {model}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
